import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Policy } from "types/generated";

const PoliciesTableUpdatedAtCell = ({
  item: policy,
  ...cellProps
}: TableSimpleCellProps<Policy>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={policy.updatedAt} variant="p-body3" />
    </TableSimpleCell>
  );
};

export default PoliciesTableUpdatedAtCell;
